var _rect, _rect2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResponsive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF6838"
    },
    cx: 256,
    cy: 255.992,
    r: 255.992
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AE4E32"
    },
    d: "M78.039,322.43L267.609,512c123.105-5.819,223.439-98.586,240.974-218.264L336.359,121.513 L78.039,322.43z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E0E0E0"
    },
    points: "260.682,380.541 153.716,380.541 169.12,301.145 245.278,301.145 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#C0C0C0"
    },
    points: "245.278,301.145 206.5,301.145 206.5,380.54 260.682,380.54 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.036,
    y: 121.516,
    style: {
      fill: "#1A1A1A"
    },
    width: 258.322,
    height: 200.914
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 206.502,
    y: 121.516,
    width: 129.856,
    height: 200.914
  })), /*#__PURE__*/React.createElement("rect", {
    x: 95.665,
    y: 138.726,
    style: {
      fill: "#35CCFF"
    },
    width: 223.063,
    height: 173.495
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.502,
    y: 138.726,
    style: {
      fill: "#00BAFF"
    },
    width: 112.226,
    height: 173.495
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.036,
    y: 269.662,
    style: {
      fill: "#FFFFFF"
    },
    width: 258.322,
    height: 52.771
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 206.502,
    y: 269.662,
    style: {
      fill: "#E0E0E0"
    },
    width: 129.856,
    height: 52.771
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E0E0E0"
    },
    cx: 207.202,
    cy: 293.121,
    r: 11.373
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C0C0C0"
    },
    d: "M207.199,281.745c-0.236,0-0.467,0.021-0.699,0.035v22.674c0.233,0.014,0.463,0.035,0.699,0.035 c6.281,0,11.373-5.092,11.373-11.373C218.571,286.837,213.479,281.745,207.199,281.745z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 242.992,
    style: {
      fill: "#333333"
    },
    width: 189.494,
    height: 122.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.997,
    y: 242.992,
    style: {
      fill: "#1A1A1A"
    },
    width: 95.497,
    height: 122.996
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.32,
    y: 256.302,
    style: {
      fill: "#35CCFF"
    },
    width: 162.845,
    height: 105.697
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.997,
    y: 256.302,
    style: {
      fill: "#00BAFF"
    },
    width: 82.177,
    height: 105.697
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.921,
    y: 352.209,
    style: {
      fill: "#1A1A1A"
    },
    width: 207.663,
    height: 28.332
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 335.997,
    y: 352.209,
    width: 104.577,
    height: 28.332
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsive);
export default __webpack_public_path__ + "static/media/responsive.d29670435fac0c25bb783db6197bbed7.svg";
export { ForwardRef as ReactComponent };